import { BooleanFeatureFlag, useFeatureFlag } from "@me8eon/featureflags";

export const llmModelSelectorFFName = 'llmModelSelector';
export const LlmModelSelectorFeatureFlag: BooleanFeatureFlag = {
    value: false,
    description: "Enable dynamic LLM model selector",
};

export function useLlmModelSelectorFlag() {
    return useFeatureFlag(llmModelSelectorFFName);
}
